import { cover } from '../../../../../../utility/constant/helper.constant'
import { Helper, Status } from '../../../../../../classes/helper'
import { useMontage } from '../../../../../../context/montage.context'

interface Props {
  positionX: number
}

export const WindowsFrontBars = ({ positionX }: Props): JSX.Element | null => {
  const { measure, roof, sidewall } = useMontage()

  const startPosition = -measure.userWidth / 2

  if (Status.sidewallDoorFront(sidewall)) return null

  // NEW
  const delta =
    measure.windowsFrontWidth +
    positionX * measure.windowsFrontWidth +
    cover.bar.width / 2

  return (
    <mesh
      position={[
        Helper.convertToMeter(startPosition + delta),
        Helper.convertToMeter(measure.frontHeight / 2),
        Helper.convertToMeter(measure.userDepth! - cover.bar.depth / 2),
      ]}
      castShadow={cover.terraceCover.castShadow}
      rotation={[Helper.convertAngleToRadiant(90), 0, 0]}
    >
      <boxGeometry
        args={[
          Helper.convertToMeter(cover.terraceCover.glassTie),
          Helper.convertToMeter(cover.bar.depth / 2),
          Helper.convertToMeter(measure.frontHeight - cover.bar.height / 2),
        ]}
      />
      <meshPhysicalMaterial color={roof.userColor} />
    </mesh>
  )
}
